import { Box, Container, Typography, Divider } from "@mui/material";

export default function WebsiteFooter({ settings, school, variant = "modern" }) {
  const isClassic = variant === "classic";
  const isBold = variant === "bold";

  return (
    <Box
      component="footer"
      sx={{
        mt: 8,
        py: 4,
        bgcolor: isBold ? "grey.900" : isClassic ? "grey.100" : "grey.50",
        borderTop: "1px solid",
        borderColor: "divider",
      }}
    >
      <Container maxWidth="lg">
        <Box display="flex" flexDirection={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ sm: "center" }} gap={2}>
          <Box>
            <Typography
              variant="subtitle2"
              fontWeight={700}
              sx={{ color: isBold ? "white" : "text.primary", fontFamily: isClassic ? "Georgia, serif" : "inherit" }}
            >
              {school?.name}
            </Typography>
            {school?.address && (
              <Typography variant="caption" sx={{ color: isBold ? "grey.400" : "text.secondary" }}>
                {school.address}
              </Typography>
            )}
          </Box>
          <Typography variant="caption" sx={{ color: isBold ? "grey.400" : "text.secondary" }}>
            {settings?.footer_text || `© ${new Date().getFullYear()} ${school?.name || ""}. All rights reserved.`}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
